import {useMemo} from "react";

import {useTranslation} from "react-i18next";

export const useLanguages = () => {
  const {t} = useTranslation();

  const LANGUAGES = useMemo(() => {
    const prod_eu = window.location.host.includes("ava.vivanti.eu");

    return [
      {id: 0, name: t("language.en"), value: "en"},
      ...(!prod_eu ? [{id: 1, name: t("language.ru"), value: "ru"}] : []),
    ];
  }, [t]);

  return {LANGUAGES};
};
